<template>
    <v-select
        v-model="value"
        :items="items"
        :label="label"
        :item-title="itemTitle"
        :item-value="itemValue"
        hide-details
    />
    <div style="color: rgb(176,0,32); font-size: 12px; margin-left: 4px;">{{ errorMessage }}</div>
</template>

<script setup>
import { useField } from 'vee-validate';

const props = defineProps({
    itemTitle: {
        type: String,
        default: 'title',
    },
    itemValue: {
        type: String,
        default: 'value',
    },
    items: {
        type: Array,
        default: () => [],
    },
    label: {
        type: String,
        default: '',
    },
    name: String,
});

const { value, errorMessage } = useField(() => props.name);
</script>
